/* eslint-disable import/no-cycle */
import { getMySites, getMySitesByOwner } from './services/site-api';

export const SET_MY_SITES = 'sites/SET_MY_SITES';
export const FETCH_MY_SITES = 'sites/FETCH_MY_SITES';
export const SET_SELECTED_OWNER = 'sites/SET_SELECTED_OWNER';

export const sitesStore = {
  state: {
    mySites: null,
    selectedOwner: null,
  },
  mutations: {
    [SET_MY_SITES](state, { mysites }) {
      state.mySites = mysites;
    },
    [SET_SELECTED_OWNER](state, selectedOwner) {
      state.selectedOwner = selectedOwner;
    },
  },
  getters: {
    mySites: (state) => state.mySites,
    selectedOwner: (state) => state.selectedOwner,
  },
  actions: {
    [FETCH_MY_SITES]: async ({ commit }, payload) => {
      const {
        userEmail, ownerId, ownerContactId, regId,
      } = payload;
      commit(SET_MY_SITES, { mysites: null });
      let resp = null;
      if (ownerId > 0 && ownerContactId > 0) {
        resp = await getMySitesByOwner(ownerId, ownerContactId, userEmail, regId);
      } else if (userEmail && userEmail !== '' && userEmail !== 'null') {
        resp = await getMySites(userEmail, regId);
      }
      let result = [];
      if (resp?.data) {
        resp.data.forEach((site) => {
          if (site == null) return null;
          let temp = null;
          temp = site;
          temp.ownerContact = `${site.ownerContact_FName} ${site.ownerContact_LName}`;
          result = [...result, temp];
          return null;
        });
      }
      commit(SET_MY_SITES, { mysites: result });
    },
  },
};
